export const cacheKey = 'saved-filters'
export const url = 'filters/?api-version=3.3'
